
define('text!views/invite/invitationitem.html',[],function () { return '<li>\r\n\t<p class="invitation-name"><%- this.name %></p>\r\n\t<p class="invitation-details"><span class="js-invitation-status invitation-status<%= ((this.acceptedDT) ? \' accepted\' : \'\' ) %>"><%- this.status %></span><span class="js-invitation-time invitation-time"><%- this.date %></span></p>\r\n</li>';});

